import { render, staticRenderFns } from "./DemoLogin.vue?vue&type=template&id=4e51d951&scoped=true&"
import script from "./DemoLogin.vue?vue&type=script&lang=js&"
export * from "./DemoLogin.vue?vue&type=script&lang=js&"
import style0 from "./DemoLogin.vue?vue&type=style&index=0&id=4e51d951&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e51d951",
  null
  
)

export default component.exports